import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";

type SearchRequest = {
  indexName: string;
  params?: {
    hitsPerPage?: number;
    page?: number;
    query?: string;
  };
};

const disabledSearchClient = {
  clearCache: () => {},
  search: async (requests: readonly SearchRequest[]) => ({
    results: requests.map(({ indexName, params }) => ({
      hits: [],
      nbHits: 0,
      page: params?.page ?? 0,
      nbPages: 0,
      hitsPerPage: params?.hitsPerPage ?? 20,
      processingTimeMS: 0,
      exhaustiveNbHits: true,
      exhaustiveFacetsCount: true,
      query: params?.query ?? "",
      params: "",
      index: indexName,
      facets: {},
      facets_stats: {},
    })),
  }),
  searchForFacetValues: async (requests: readonly unknown[]) =>
    requests.map(() => ({
      facetHits: [],
      exhaustiveFacetsCount: true,
      processingTimeMS: 0,
    })),
} as unknown as ReturnType<typeof instantMeiliSearch>["searchClient"];

const disabledMeiliSearch = {
  searchClient: disabledSearchClient,
  setMeiliSearchParams: () => {},
  meiliSearchInstance: null,
} as unknown as ReturnType<typeof instantMeiliSearch>;

export const initMeiliSearch = () => {
  const host = process.env.NEXT_PUBLIC_MEILISEARCH_HOST;
  const apiKey = process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY;

  if (!host || !apiKey) {
    return disabledMeiliSearch;
  }

  return instantMeiliSearch(host, apiKey, {
    primaryKey: "id",
    meiliSearchParams: {
      rankingScoreThreshold: 0.5,
    },
  });
};
